import { imagePrefix } from '@/constants';
import React from 'react';
import styles from './index.less';

interface IListTitleProps {
  title: string;
}

const ListTitle: React.FC<IListTitleProps> = ({ title }) => {
  return (
    <div
      className={styles.index}
      style={{
        backgroundImage: `url(${imagePrefix('list-title-bgc.png')})`
      }}
    >
      {title}
    </div>
  );
};

export default ListTitle;